import React, { Component } from "react";
import { Container } from "./components/windows";
import { Document } from "./components/document";
import { TopNav, ToolBar, PropertiesPanel, Hierarchy } from './components/ui';
import { Timeline } from './components/timeline';

import "./App.css";

const MainContainer = Container;

class App extends Component {

  constructor() {
    super();

    this.document = null;
  }

  componentDidMount() {
   //console.log(this.document.htmlDocument, this.refs);
   this.propertiesPanel = this.refs.propsPanel;
   this.mainContainer = this.refs.mainContainer;
   this.toolBar = this.refs.toolbar;
   this.topNav = this.refs.topnav;
   this.timeline = this.refs.timeline;
   this.hierarchy = this.refs.hierarchy

   // this.mainContainer.on('zoomChange', (newZoom) => this.updateNav());

   this.setDocumentForAll(this.document);
   this.setContainerForToolBar(this.mainContainer)

   this.updateNav();
  }

  updateNav() {
    this.topNav.setLinks({
      container: this.mainContainer
    });
  }

  setContainerForToolBar(cont) {
    this.toolBar.setContainer(cont);
    this.mainContainer.setToolBar(this.toolBar);
  }

  setDocumentForAll(doc) {
    this.propertiesPanel.setDocument(doc);
    this.hierarchy.setDocument(doc);
  }

  onToolChanged(tool) {
    const fullCursor = tool.getCursor(true);
    this.mainContainer.setCursor(fullCursor);
    if(tool.name !== 'selection') {
      this.document.hideAllTransformControls();
    }
  }

  render() {
    return (
      <div className="app">
        <MainContainer
          ref='mainContainer'
          innerWidth={5000}
          innerHeight={3000}
          className="mainContainer"
          zoom={0.5}
          events={true}
        >
            <Document onRef={(ref) => this.document = ref} width={1920} height={1080} />
        </MainContainer>
        <ToolBar ref='toolbar' onToolChanged={this.onToolChanged.bind(this)} />
        <TopNav ref='topnav' />
        <PropertiesPanel ref='propsPanel'/>
        <Hierarchy ref='hierarchy'/>
        <Timeline className="timeline" ref='timeline' />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js